"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getApplicableRewards = function getApplicableRewards(_ref) {
  var offer = _ref.offer,
    rewards = _ref.rewards;
  var offerTypes = offer === null || offer === void 0 ? void 0 : offer.offerTypes;
  return (0, _lodash["default"])(offerTypes).map(function (offerType) {
    var _offerType$identifier;
    var fulfilledAfterDays = offerType.fulfilledAfterDays;
    if ((0, _fp.isEmpty)(rewards)) {
      var _offerType$descriptio;
      var description = offerType === null || offerType === void 0 || (_offerType$descriptio = offerType.description) === null || _offerType$descriptio === void 0 || (_offerType$descriptio = _offerType$descriptio[0]) === null || _offerType$descriptio === void 0 || (_offerType$descriptio = _offerType$descriptio.children) === null || _offerType$descriptio === void 0 || (_offerType$descriptio = _offerType$descriptio[0]) === null || _offerType$descriptio === void 0 ? void 0 : _offerType$descriptio.text;
      return description ? {
        fulfilledAfterDays: fulfilledAfterDays,
        text: description
      } : null;
    }
    var rewardsIds = rewards === null || rewards === void 0 ? void 0 : rewards[offerType === null || offerType === void 0 || (_offerType$identifier = offerType.identifier) === null || _offerType$identifier === void 0 ? void 0 : _offerType$identifier.current];
    var matchingReward = (0, _fp.find)(function (_ref2) {
      var identifier = _ref2.identifier;
      return (0, _fp.includes)(identifier === null || identifier === void 0 ? void 0 : identifier.current, rewardsIds);
    }, offerType.givesAccessToOneOfRewards);
    return matchingReward ? {
      fulfilledAfterDays: fulfilledAfterDays,
      text: matchingReward === null || matchingReward === void 0 ? void 0 : matchingReward.name
    } : null;
  }).compact().value();
};
var _default = exports["default"] = getApplicableRewards;
module.exports = exports.default;